/* eslint-disable import/no-unresolved */
 <template>
  <v-main>
    <v-container fluid style="padding: 0">
      <v-card
        class="elevation-0 hide-overflow d-flex flex-column align-stretch"
        height="100vh"
      >
        <section class="search-row">
          <PositionSearch />
        </section>
        <v-row class="pa-6 align-center campaign-banner" v-if="showCampaign">
          <v-dialog
            v-model="campaign.terms.show"
            v-if="!termsAccepted"
            persistent
            max-width="600"
          >
            <v-card class="campaign">
              <v-card-title class="headline b-b mb-4">
                <img :src="campaign.imageUrl" class="logo" alt="" />
              </v-card-title>
              <v-card-text class="b-b">
                <h2 class="mb-4">{{ campaign.terms.title }}</h2>
                <div>{{ campaign.terms.description }}</div>
              </v-card-text>
              <v-card-actions>
                <div class="ma-4" style="font-size: 14px">
                  By clicking Accept, you accept the
                  <a :href="campaign.terms.externalUrl" target="_blank"
                    >Terms and conditions</a
                  >
                  of the campaign.
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="
                    campaign.terms.show = false;
                    $router.push('/');
                  "
                >
                  Disagree
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="campaign.terms.show = false"
                >
                  Accept
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-col col="12" md="2"
            ><h2 style="color: #fff; margin: 0">{{ campaign.title }}</h2></v-col
          >
          <v-col col="12" md="6">{{ campaign.description }}</v-col>
          <v-col col="12" md="4" class="text-right">
            <v-btn
              text
              :href="campaign.externalUrl"
              target="_blank"
              color="white"
            >
              Read more
              <v-icon right>mdi-open-in-new</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="loading">
          <v-col>
            <Loader />
          </v-col>
        </v-row>
        <section
          v-else-if="errored"
          style="
            padding: 0 2em;
            height: 92vh;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          "
        >
          <p>
            We're sorry, we're not able to retrieve this information at the
            moment, please try back later
          </p>
        </section>
        <v-row v-else no-gutters class="hide-overflow main-content">
          <v-col cols="12" md="6" class="chart hide-overflow d-none d-sm-block">
            <!-- 
            <div class="pa-2 d-none d-sm-flex align-center justify-center b-b">
              JOB SIMILARITY
            </div>
            <ClusterChart
              :searchTerms="getSearchTerms"
              :graph="getSearchResults"
            /> -->
            <div class="pa-2 d-none d-md-flex align-center justify-center b-b">
              JOB MAP
            </div>
            <PositionMap />
            <v-container
              class="b-t active-position"
              fluid
              v-if="activePositionItem !== null"
            >
              <v-row class="align-center">
                <v-col cols="2" md="2">
                  <div
                    v-if="activePositionItem.imageURL"
                    class="position-logo"
                    v-bind:style="{
                      'background-image':
                        'url(' + activePositionItem.imageURL + ')',
                    }"
                  ></div>
                  <div v-else class="position-logo">
                    <div style="width: 100%; margin-bottom: 0">
                      {{ activePositionItem.organization }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="6" md="6">
                  <div class="position-title">
                    {{ activePositionItem.title }}
                  </div>
                  <div class="position-subtitle">
                    {{ activePositionItem.organization }}
                  </div>
                  <div
                    class="position-tag-wrapper"
                    v-if="activePositionItem.clustering.categories[0]"
                  >
                    <span
                      v-bind:class="[
                        'position-tag',
                        activePositionItem.clustering.categories[0].label,
                      ]"
                    >
                      {{ activePositionItem.clustering.categories[0].label }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="2" md="2">
                  <div class="position-title">
                    {{ activePositionItem.location.city }}
                  </div>
                  <div class="position-subtitle">
                    {{ activePositionItem.location.area }}
                  </div>
                </v-col>
                <v-col cols="2" md="2">
                  <v-btn
                    icon
                    class="position-open"
                    @click="openUrl(activePositionItem.url)"
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                  <v-btn icon @click="saveFavorite()">
                    <v-icon v-if="!isFavorite">mdi-star-outline</v-icon>
                    <v-icon color="primary" v-else>mdi-star</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" md="6" class="list hide-overflow">
            <PositionList
              :activePosition="getSelectedPosition"
              :graph="getSearchResults"
              :featuredJobs="featuredJobs"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios';
import ClusterChart from '@/components/ClusterChart.vue';
import PositionList from '@/components/PositionList.vue';
import PositionSearch from '@/components/PositionSearch.vue';
import StaticFinlandMap from '@/components/StaticFinlandMap.vue';
import PositionCount from '@/components/PositionCount.vue';
import ActivePositionCard from '@/components/ActivePositionCard.vue';
import Loader from '@/components/Loader.vue';
import PositionMap from '@/components/PositionMap.vue';

export default {
  name: 'Index',
  components: {
    ClusterChart,
    PositionCount,
    PositionList,
    PositionSearch,
    StaticFinlandMap,
    ActivePositionCard,
    Loader,
    PositionMap,
  },
  data() {
    return {
      tab: null,
      errored: false,
      loading: true,
      positionCount: 0,
      showCampaign: false,
      showCampaignJobs: false,
      termsAccepted: false,
      campaignId: '',
      featuredJobs: [],
    };
  },
  mounted() {
    this.getJobs();

    window.addEventListener('keyup', (e) => {
      if (e.keyCode == 70) {
        console.log(e.keyCode);
        this.saveFavorite();
      }
    });

    this.checkCampaign();

    // Get pinned jobs
    this.$store
      .dispatch('dispatchGetCampaignJobs', { campaignId: 'featured-jobs', replaceResults: false })
      .then((jobs) => {
        this.featuredJobs = jobs.map((job) => {
          job['featured'] = true;
          return job;
        });
      });
  },
  watch: {},
  methods: {
    getJobs() {
      this.$store
        .dispatch('dispatchGetJobs')
        .catch(() => {
          this.loading = false;
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Method to update data to vuex store
    updateJobs(data) {
      this.$store.dispatch('commitJobs', data);
    },
    checkCampaign() {
      if (this.$route.name === 'campaign') {
        this.campaignId = this.$route.params.id;
        // NOTE: GET Campaign uses SLUG and GET Campaign Jobs uses ID
        this.$store
          .dispatch('dispatchGetCampaign', { campaignId: this.campaignId })
          .catch(() => {
            this.$router.push('/');
          })
          .then(() => {
            // Check terms
            this.showCampaign = true;
            this.termsAccepted = this.$route.query.termsaccepted !== undefined;

            this.$store
              .dispatch('dispatchGetCampaignJobs', {
                campaignId: this.campaign.id,
              })
              .then(() => {
                this.showCampaignJobs = true;

                // Filter results

                const terms = {
                  area: this.$route.query.areas ? this.$route.query.areas : '',
                  keywords: this.$route.query.keyword
                    ? this.$route.query.keyword
                    : '',
                };

                this.$store.dispatch('commitSearchTerms', terms);
                this.$store.dispatch('commitSearchResults', terms);
              });

            // Check if campaign has jobs, else use filter mode
            /* if(this.campaign.filters.areas.length > 0 || this.campaign.filters.categories.length > 0){
            this.$store.dispatch("dispatchGetJobs").then((jobs) => {

              let terms = {
              area: this.campaign.filters.areas.join(''),
              keywords: this.campaign.filters.categories.join('')
              }

              this.$store.dispatch("commitSearchTerms", terms);
              this.$store.dispatch("commitSearchResults", terms);
              
              this.showCampaignJobs = false;

            });
          } else{
            // NOTE: GET Campaign Jobs uses ID and GET Campaign uses SLUG
            this.$store.dispatch("dispatchGetCampaignJobs", { campaignId: this.campaign.id }).then((jobs) => {
              console.log(jobs);
              if(jobs.length > 0){
                this.showCampaignJobs = true;
              }
              else{
                this.$store.dispatch("dispatchGetJobs");
                this.showCampaignJobs = false;
              }
            });
          } */
          });
      } else {
        this.showCampaign = false;
        this.showCampaignJobs = false;
      }
    },
    openUrl(url) {
      window.open(url);
    },
    saveFavorite() {
      this.$store.dispatch('commitFavorite', {
        jobId: this.activePositionItem.id,
        action: this.isFavorite ? 'remove' : 'add',
      });
    },
  },
  computed: {
    // Get data from vuex store
    getSearchResults() {
      return this.$store.state.searchResults;
    },
    getSelectedPosition() {
      return this.$store.state.selectedPosition;
    },
    getSearchTerms() {
      return this.$store.state.searchTerms;
    },
    campaign() {
      return this.$store.state.campaign;
    },
    activePositionItem() {
      return this.$store.state.selectedPosition;
    },
    isFavorite() {
      return (
        this.$store.state.userFavorites.findIndex(
          item => item.id === this.activePositionItem.id,
        ) > -1
      );
    },
  },
};
</script>
<style scoped>
.loading-container {
  height: calc(100vh - 273px);
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
}
.main-search {
  margin-top: 0.5em;
  margin-bottom: -0.8em;
}
.list {
  background: #f0f0f0;
  min-height: 80vh;
}
.tabs {
  display: block;
}
.campaign-banner {
  background: rgba(0, 45, 160, 1);
  color: white;
}
.v-dialog .campaign h2 {
  text-transform: uppercase;
  color: rgba(0, 45, 160, 1);
}
.v-dialog .campaign div {
  color: rgba(0, 45, 160, 1);
}
.v-dialog .campaign .logo {
  max-height: 80px;
}
.active-position {
  font-size: 0.7rem;
}
.active-position {
  background: #fff;
}
.active-position .position-logo {
  width: 100%;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 1;
  text-align: center;
  display: flex;
  align-content: center;
  align-items: center;
  height: 64px;
  color: rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  background-color: #fff;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.active-position .position-title {
  font-size: 1.1em;
  line-height: 1.2em;
  font-weight: 400;
}
.active-position .position-subtitle {
  font-size: 1em;
  opacity: 0.7;
}
.active-position .position-tag {
  font-size: 0.9em;
  color: rgba(0, 45, 160, 1);
  text-transform: uppercase;
}
.main-content {
}
@media screen and (min-width: 992px) {
  .list {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    background: transparent;
    min-height: auto;
  }
  .search-row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
  .main-content {
    flex-wrap: nowrap;
  }
  .tabs {
    display: none;
  }
  .active-position {
    font-size: 0.9rem;
  }
}
</style>
